import { useEffect } from 'react'
import { addListener } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from 'react-redux'
import {
  ERROR_ACTION,
  GET_MEDIA_FILE_SUCCESS,
  LOAD_ACTION,
  SET_FILE_POP_UP_MEDIA_FILE_TAGS_SUCCESS,
} from './FilePopUpConstants'
import { getErrorMessage } from './FilePopUpActions'
import { getStateRules } from '../../utils/common'
import { GET_PATIENT_INFO_SUCCESS, SET_MEDIA_FILE_TAGS_SUCCESS } from '../charts/ChartsConstants'
import { getPatient } from '../patient/PatientThunk'
import { GET_PATIENT_INFORMATION_SUCCESS } from '../patient/PatientConstants'

const FilePopUpListener = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  tabId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  onGetMediaFileSuccess,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  onCloseFilePopUp,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  onSetLoading,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setToastMessage,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  onUpdateFile,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  patientId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  fileId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  stateCode,
}) => {
  const dispatch = useDispatch()
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const settingsPerState = useSelector((state) => state.management.statesSettings.SettingsPerState)

  useEffect(() => {
    if (stateCode) {
      onUpdateFile({ patientDrugRules: getStateRules(stateCode, settingsPerState) })
    }
  }, [settingsPerState])
  useEffect(() => {
    const unsubscribe = dispatch(
      addListener({
        predicate: () => true,
        effect: async (action) => {
          switch (action.type) {
            case LOAD_ACTION:
              onSetLoading(true)
              break
            case GET_MEDIA_FILE_SUCCESS:
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              if (action.extraData?.tabId === tabId) {
                onSetLoading(false)

                // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
                const patientDrugRules = getStateRules(action.extraData.patient.StateCode, settingsPerState)
                onGetMediaFileSuccess(
                  {
                    // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
                    ...action.payload,
                    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
                    patientId: action.extraData.patient.PatientId,
                    patientDrugRules,
                    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                    isFile: action.extraData?.isFile,
                  },
                  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
                  action.extraData.patient.PatientId,
                  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
                  action.payload.FileId || action.extraData.patient.DrugScreen.FileId,
                  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
                  action.extraData.patient.StateCode,
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  action.extraData?.isFile,
                )
              } else {
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                console.log('TabId mismatch:', action.extraData?.tabId, 'Expected:', tabId) // Log if tabId does not match
              }
              break
            case SET_FILE_POP_UP_MEDIA_FILE_TAGS_SUCCESS:
            case SET_MEDIA_FILE_TAGS_SUCCESS:
              // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
              if (action.extraData.tabId === tabId && action.type === SET_FILE_POP_UP_MEDIA_FILE_TAGS_SUCCESS) {
                // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
                dispatch(getPatient(patientId, tabId, { loadAction: LOAD_ACTION, errorAction: ERROR_ACTION }))
                // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
              } else if (action.extraData.patientId === patientId && action.payload.data?.FileId === fileId) {
                // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
                onUpdateFile(action.payload.data)
              }
              break
            case GET_PATIENT_INFO_SUCCESS:
            case GET_PATIENT_INFORMATION_SUCCESS:
              // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
              if (action.extraData.tabId === tabId) {
                onCloseFilePopUp()
                onSetLoading(false)
                // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
              } else if (action.extraData.patientId === patientId && action.payload.DrugScreen?.FileId !== fileId) {
                onCloseFilePopUp()
              }
              break
            case ERROR_ACTION:
              onSetLoading(false)
              setToastMessage(getErrorMessage(action))
              break
            default:
              break
          }
        },
      }),
    )
    return () => {
      // @ts-expect-error TS2349 -- MIGRATION: not approved, fix when encountered
      if (unsubscribe) unsubscribe()
    }
  }, [patientId, fileId, settingsPerState])

  return null
}

export default FilePopUpListener
